module.exports = __webpack_public_path__ + "static/media/donet-development-training.5a98d5ce.png";